import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';
import {MatSnackBar} from '@angular/material/snack-bar';
@Component({
  selector: 'kt-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  form = {
    username: '',
    password: ''
  };
 
  loading = false;
  constructor(private router: Router, private cs: ApiService, private _snackBar: MatSnackBar) { }

  ngOnInit() { }

  validate() {
    if (!this.form['username']) {
      this.cs.alert('Username is mandatory');
      return false;
    } else if (!this.form['password']) {
      this.cs.alert('password is mandatory');
      return false;
    }
    this.login();
  }

  login() {
    let postParams = this.form;
    this.loading = true;

    this.cs.httpService('post', 'AdminUsers/adminLogin', {}, postParams).subscribe(
      data => {
        data = data.data;
        if (data) {
          if (data.token) {
            localStorage.setItem('token', data.token);
            localStorage.setItem('role', data.role);
            localStorage.setItem('username',data.username);
            localStorage.setItem('userid',data.user_id);
            this.cs.role = data.role;
            this.router.navigate(['/']);
          } else {
            this.cs.alert(data.message);
          }
        } else {
          this.openSnackBar();
        }
      },
      err => {
        this.cs.alert(err.statusText);
        // this.cs.alert("Invalid Username or Password");
      }
    );
  }
  openSnackBar() {
    this._snackBar.open('Invalid Credential', 'Close', {
      duration: 2000,
    });
  }
}
